import axios from "axios";
import {
  API_URL,
  GYPSYBALL_PYTHON_API_URL,
  GYPSYBALL_PYTHON_API_TOKEN,
} from "configs";

import { isEmpty } from "lodash";
import { useDispatch } from "react-redux";

import { v4 as uuidv4 } from "uuid";
export const INCIDENT_REQUEST = "INCIDENT_REQUEST";
export const INCIDENT_SUCCESS = "INCIDENT_SUCCESS";

export const INCIDENT_VALIDATION_ERROR = "INCIDENT_VALIDATION_ERROR";
const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_INCIDENT_FEILD_VALIDATION_ERROR =
  "HIDE_INCIDENT_FEILD_VALIDATION_ERROR";
export const REDIRECT_TO_INCIDENT_LIST = "REDIRECT_TO_INCIDENT_LIST";
export const INCIDENT_CATEGORIES_REQUEST = "INCIDENT_CATEGORIES_REQUEST";
export const INCIDENT_CATEGORIES_SUCCESS = "INCIDENT_CATEGORIES_SUCCESS";
export const DEPARTMENTS_SUCCESS = "DEPARTMENTS_SUCCESS";
export const INCIDENT_GET_SUCCESS = "INCIDENT_GET_SUCCESS";
export const INCIDENT_DROPDOWN_LIST_SUCCESS = "INCIDENT_DROPDOWN_LIST_SUCCESS";
export const INCIDENT_SERVER_SUCCESS = "INCIDENT_SERVER_SUCCESS";
export const SCOPE_USER_INCIDENT_SUCCESS = "SCOPE_USER_INCIDENT_SUCCESS";
export const INCIDENT_INSTRUCTIONS_REQUEST = "INCIDENT_INSTRUCTIONS_REQUEST";
export const INCIDENT_INSTRUCTIONS_SUCCESS = "INCIDENT_INSTRUCTIONS_SUCCESS";

const SHOW_LOADER = "SHOW_LOADER";
const HIDE_LOADER = "HIDE_LOADER";

const showCommonLoader = (label = "") => ({
  type: SHOW_LOADER,
  common_loder_label: label,
});
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
});

const incidentRequest = () => ({
  type: INCIDENT_REQUEST,
});

const incidentCategories = () => ({
  type: INCIDENT_CATEGORIES_REQUEST,
});

const incidentCategoriesListSuccess = (
  incidentCategoriesList,
  incidentFormValues
) => ({
  type: INCIDENT_CATEGORIES_SUCCESS,
  incidentCategoriesList: incidentCategoriesList,
  incidentFormValues: incidentFormValues,
});

const incidentInstructions = () => ({
  type: INCIDENT_INSTRUCTIONS_REQUEST,
});

const incidentInstructionsListSuccess = (incidentInstructionsList) => ({
  type: INCIDENT_INSTRUCTIONS_SUCCESS,
  incidentInstructionsList: incidentInstructionsList,
});
export const incidentServerListSuccess = () => ({
  type: INCIDENT_SERVER_SUCCESS,
});

const incidentListSuccess = (incidentList) => ({
  type: INCIDENT_SUCCESS,
  incidentList: incidentList,
});

const deparmentsListSuccess = (departmentsDropdownList) => ({
  type: DEPARTMENTS_SUCCESS,
  departmentsDropdownList: departmentsDropdownList,
});

export const incidentFailure = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "general_error",
});

const validationError = (notification) => ({
  type: INCIDENT_VALIDATION_ERROR,
  validation_error: notification,
});
const tokenError = (notification) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: "token_expire",
});

const incidentAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(incidentSuccessNotification(message));
  //dispatch(redirectToIncidentList());
};

export const redirectToIncidentList = () => ({
  type: REDIRECT_TO_INCIDENT_LIST,
});

const getIncidentSuccess = (response, action) => ({
  type: INCIDENT_GET_SUCCESS,
  record: response,
  actionType: action,
});

const incidentSuccessNotification = (message) => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: "success",
});

export const hideIncidentValidationError = (feild_key) => ({
  type: HIDE_INCIDENT_FEILD_VALIDATION_ERROR,
  feild_key: feild_key,
});

export const incidentListFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getAll", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(incidentListSuccess(response.data));
        //dispatch(incidentCategoriesListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

const scopeUserIncidentListSuccess = (incidentList) => ({
  type: SCOPE_USER_INCIDENT_SUCCESS,
  scopeUserIncidentList: incidentList,
});

export const scopeUserIncidentListFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getAllScopeUserIncident", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(scopeUserIncidentListSuccess(response.data));
        //dispatch(incidentCategoriesListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const incidentInitiationListFetch = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getAllIncidentInitiation", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(incidentListSuccess(response.data));
        //dispatch(incidentCategoriesListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getIncidentById = (id, action) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getById/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(getIncidentSuccess(response.data, action));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getIncidentFormValues = (names) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentCategories());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getFormValues", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        names: names,
      },
    })
      .then((response) => {
        dispatch(incidentCategoriesListSuccess(response.data, []));
        dispatch(hideCommonLoader());
      })
      .catch((error) => {
        handleErrorResponse(error, dispatch);
        dispatch(hideCommonLoader());
      });
  };
};

export const getAllDepartments = () => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getAllDepartments", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(deparmentsListSuccess(response.data));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// Add Incident Tab
export const addIncidentInitiation = (data) => {
  console.log("data", data);

  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/create", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        incidentAddUpadteSuccess(
          "Incident Initiated Successfully",
          "create",
          dispatch
        );
        dispatch(hideCommonLoader());
        dispatch(redirectToIncidentList());
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error; // pass error to caller
      }
    );
  };
};

// update Incident Tab
export const updateIncidentInitiation = (data, id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/update/" + id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        incidentAddUpadteSuccess(
          "Incident Initiated Successfully",
          "create",
          dispatch
        );
        dispatch(hideCommonLoader());
        dispatch(redirectToIncidentList());
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error; // pass error to caller
      }
    );
  };
};

export const audioTranscribe = (filesData) => {
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());

    const token = localStorage.getItem("token");

    return axios(GYPSYBALL_PYTHON_API_URL + "transcribe-audio", {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
      },
      data: filesData,
      method: "POST",
    })
      .then((response) => {
        dispatch(hideCommonLoader());

        response = !isEmpty(response.data && response.data.results)
          ? response.data.results[0]
          : [];

        if (!isEmpty(response.error)) {
          dispatch(incidentFailure(response.error));
        } else {
          dispatch(
            incidentSuccessNotification("Audio Transcribed successfully")
          );
          return response.transcription;
        }

        return "";
        //chatAttachmentSuccess("Audio Uploaded Successfully", dispatch);
        //dispatch(getChatAttachmentSuccess(response.data));
      })
      .catch((error) => {
        dispatch(hideCommonLoader());

        handleErrorResponse(error, dispatch);
        return "";
      });
  };
};

// Add Incident Review
export const addIncidentReview = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentReview", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Review Added Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// Update Incident Review
export const updateIncidentReview = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentReview", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Review Added Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Add Incident Investigation
export const addIncidentInvestigation = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentInvestigation", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Investigation Added Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Update Incident Investigation
export const updateIncidentInvestigation = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentInvestigation", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Review Added Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Add Incident Resolution
export const addIncidentResolution = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentResolution", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Resolution Added Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

//Update Incident Resolution
export const updateIncidentResolution = (data) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/incidentResolution", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Incident Resolution updated Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

// Add Preventive Actions
export const generateAIRootCause = (data) => {
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());

    try {
      const response = await axios(API_URL + "incident/generateRootCause", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      });

      dispatch(hideCommonLoader());

      const questions = response.data?.questions || [];

      if (questions.length > 0) {
        dispatch(
          incidentSuccessNotification("Questions Generated Successfully")
        );
        return questions;
      } else {
        dispatch(
          incidentFailure("No questions could be generated. Please try again.")
        );
        return [];
      }
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
      throw error;
    }
  };
};

export const saveAiGeneratedQuestions = (data) => {
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());

    try {
      const response = await axios(API_URL + "incident/saveAIQuestions", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      });

      dispatch(hideCommonLoader());
      dispatch(incidentSuccessNotification("AI Questions Saved Successfully"));
      dispatch(getIncidentById(data.incident_id, "update"));

      return response;
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
      throw error;
    }
  };
};

export const saveRootCauseAnalysis = (data) => {
  const incidentId = data.id;

  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/saveRootCauseAnlysis/" + incidentId, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Root Cause Analysis updated Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const saveRootCauseSummary = (data) => {
  const incidentId = data.id;

  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/saveRootCauseSummary/" + incidentId, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        incidentAddUpadteSuccess(
          "Root Cause Summary updated Successfully",
          "create",
          dispatch
        );
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const generateAIRootCauseSummary = (data) => {
  const token = localStorage.getItem("token");

  return async (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());

    try {
      const response = await axios(
        GYPSYBALL_PYTHON_API_URL + "incident-management/generate-summary",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${GYPSYBALL_PYTHON_API_TOKEN}`,
          },
          data: data,
        }
      );

      dispatch(hideCommonLoader());
      dispatch(incidentSuccessNotification("Summary Generated Successfully"));

      return response.data?.summary || ""; // return only the summary
    } catch (error) {
      dispatch(hideCommonLoader());
      handleErrorResponse(error, dispatch);
      throw error;
    }
  };
};

export const generateFinalReportForIncident = (incidentId, objectId) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/generateFinalReport/" + incidentId, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_id: objectId,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(
          incidentSuccessNotification("Final Report Generated Successfully")
        );
        dispatch(getIncidentById(incidentId));
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const generatePreviewReportForIncident = (incidentId, objectId) => {
  const token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());

    return axios(API_URL + "incident/generatePreviewReport/" + incidentId, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_id: objectId,
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader());
        dispatch(
          incidentSuccessNotification("Preview Report Generated Successfully")
        );
        dispatch(getIncidentById(incidentId));

        // 👉 just return raw response
        return response;
      })
      .catch((error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);

        // 👉 return error.response if available, otherwise error object
        return error.response || error;
      });
  };
};

export const deleteIncident = (id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/delete/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(incidentSuccessNotification("Incident deleted successfully"));
        dispatch(redirectToIncidentList());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const deleteIncidentAtInitiation = (id, object_viewed_id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/deleteIncidentAtInitiation/" + id, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: {
        object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(hideCommonLoader());
        dispatch(redirectToIncidentList());
        dispatch(incidentSuccessNotification("Incident deleted successfully"));
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const getIncidentInstructions  = (object_viewed_id = "") => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/getInstructions", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      params: {
        object_viewed_id: object_viewed_id,
      },
    }).then(
      (response) => {
        dispatch(incidentInstructionsListSuccess(response.data));
        //dispatch(incidentCategoriesListSuccess(response.data));
        dispatch(hideCommonLoader());
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
      }
    );
  };
};

export const updatePromptInstructions = (data, id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/updateInstructions/" + id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        incidentAddUpadteSuccess(
          "Root Cause Analysis Prompt added Successfully",
          "create",
          dispatch
        );
        dispatch(hideCommonLoader());
        dispatch(redirectToIncidentList());
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error; // pass error to caller
      }
    );
  };
};

export const updateSummaryInstructions = (data, id) => {
  var token = localStorage.getItem("token");
  return (dispatch) => {
    dispatch(incidentRequest());
    dispatch(showCommonLoader());
    return axios(API_URL + "incident/updateSummary/" + id, {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: data,
    }).then(
      (response) => {
        incidentAddUpadteSuccess(
          "Root Cause Summary Prompt added Successfully",
          "create",
          dispatch
        );
        dispatch(hideCommonLoader());
        dispatch(redirectToIncidentList());
        return response;
      },
      (error) => {
        dispatch(hideCommonLoader());
        handleErrorResponse(error, dispatch);
        throw error; // pass error to caller
      }
    );
  };
};
// handling error reponse
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error));
    } else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()));
    } else {
      let err = "";
      if (error.response.data.error) {
        err = error.response.data.error.toString();
      } else {
        err = error.response.status + ` ` + error.response.statusText;
      }
      dispatch(incidentFailure(err));
    }
  } catch (e) {
    dispatch(incidentFailure("Unable to perform action.Something went wrong"));
  }
};
